// extracted by mini-css-extract-plugin
export default {"table":"result-table_table__BH-q+ table","header":"result-table_header__ErOR7","spinner":"result-table_spinner__yu8-t","noResultsMessage":"result-table_noResultsMessage__QoPPt"};